import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { CATEGORIES } from '../lib/constants'
import { fetchWantedBoard } from '../lib/wantedBoard'
import { track } from '../lib/analytics'

// Home page "Wanted near you": up to 5 open requests, nearest first when we
// know roughly where the visitor is, otherwise newest across Australia.
// Hidden completely when there are none.
export default function WantedStrip({ center }) {
const [items, setItems] = useState([])
const lat = center?.lat ?? null
const lng = center?.lng ?? null

useEffect(() => {
let cancelled = false
fetchWantedBoard({ lat, lng, limit: 5 }).then(rows => { if (!cancelled) setItems(rows) }).catch(() => {})
return () => { cancelled = true }
}, [lat, lng])

if (!items.length) return null
const near = lat != null && items.some(r => r.distance_km != null)

return (
<div className="container" style={{ marginTop: 16 }}>
<div className="card card-body" style={{ padding: '12px 16px' }}>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 8, marginBottom: 8 }}>
<div style={{ fontWeight: 700, color: 'var(--navy)', fontSize: 15 }}>🔎 {near ? 'Wanted near you' : 'Wanted on HireIt'}</div>
<Link to="/wanted" onClick={() => track('wanted_strip_click', { target: 'see_all' })} style={{ fontSize: 13, fontWeight: 600, color: 'var(--primary)', whiteSpace: 'nowrap' }}>See all →</Link>
</div>
<div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
{items.map(r => (
<Link
key={r.id}
to={`/wanted?r=${r.id}`}
onClick={() => track('wanted_strip_click', { target: 'request' })}
style={{ display: 'inline-flex', alignItems: 'center', gap: 6, maxWidth: '100%', padding: '6px 12px', borderRadius: 99, border: '1px solid var(--border)', background: 'var(--primary-pale)', color: 'var(--text)', fontSize: 13, textDecoration: 'none' }}
>
<span aria-hidden="true">{CATEGORIES.find(c => c.id === r.category_id)?.icon || '📦'}</span>
<span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
<strong style={{ fontWeight: 600 }}>{r.title}</strong> – {r.suburb}
</span>
</Link>
))}
</div>
</div>
</div>
)
}
